import React from 'react';
import { linkHelper } from '../../utils/linkHelper';

interface Props {
    children?: React.ReactElement | React.ReactText | Array<React.ReactElement | React.ReactText>
    href: HTMLLinkElement["href"],
    className?: HTMLLinkElement["className"],
    rel?: string,
    stay?: boolean,                                     // Attr `stay` would defaultly be false, which means it's a jump outside ecosphere.
    style?: any,
    title?: HTMLLinkElement["title"],                   // Attr `title` would be replaced by children.toStirng() by default.
}

const getInnerHTML = (child: React.ReactElement | React.ReactText | Array<React.ReactElement | React.ReactText>): React.ReactText => {
    if (Array.isArray(child)) {
        return '';
    }
    if (typeof child === 'string' || typeof child === 'number') {
        return child;
    }
    if (child.props && child.props.children) {
        return getInnerHTML(child.props && child.props.children);
    }
    return '';
};

export const LinkWrapper = (props: Props) => {
    const { stay = false, href, className, title, children, style = {} } = props;
    const target = stay ? '' : '_blank';
    // let displayTitle: React.ReactText = '';
    // if (typeof title === 'undefined' && typeof children !== 'undefined') {
    //     displayTitle = getInnerHTML(children);
    // } else {
    //     displayTitle = title;
    // }
    if (href) {
        return (
            <a href={linkHelper(href)} target={target} className={className} title={title} style={style}>
                {children || ''}
            </a>
        );
    }
    return (
        <a href="javascript:void(0)" className={className} title={title} style={style}>
            {children || ''}
        </a>
    );
};



// WEBPACK FOOTER //
// ./src/components/BaseComp/LinkWrapper.tsx